import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=36dc2dda&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36dc2dda')) {
      api.createRecord('36dc2dda', component.options)
    } else {
      api.reload('36dc2dda', component.options)
    }
    module.hot.accept("./Ask.vue?vue&type=template&id=36dc2dda&", function () {
      api.rerender('36dc2dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Ask.vue"
export default component.exports